// @flow

export const subscribeAnimationFrame = (onFrame: Function) => {
  let isListening = false;
  const listenToFrame = () => {
    requestAnimationFrame((...args) => {
      if (isListening) {
        onFrame(...args);
        listenToFrame();
      }
    });
  };
  isListening = true;
  listenToFrame();
  return () => {
    isListening = false;
  };
};
